<template>
<div class="popOrderView" v-if="centerDialogVisible">
    <el-dialog title="订单详情" :visible.sync="centerDialogVisible" width="720px" center>
        <div class="outbox userinfo">
            <div class="box hbox">
                <span class="name">订单号：</span>
                <span class="value">{{item.orderinfo.orderno}}</span>
            </div>
            <div class="box hbox">
                <span class="name">购买人：</span>
                <img class="img"  :src="item.orderinfo.customericonurl" alt="" v-if="item.orderinfo.customericonurl">
                <span class="value">{{item.orderinfo.customername}}</span>
            </div>
            <div class="box">
                <span class="name">支付金额：</span>
                <span class="value">￥{{item.orderinfo.finalpaymoney}}</span>
            </div>
            <div class="box">
                <span class="name">支付状态：</span>
                <span class="value">{{item.orderinfo.paystatustext}}</span>
            </div>
            <div class="box">
                <span class="name">订单时间：</span>
                <span class="value">{{item.orderinfo.datetime}}</span>
            </div>
        </div>
        <div class="outbox">
            <div class="box" v-if="item.orderinfo.parentname01">
                <span class="name">直接上级：</span>
                <span class="value">{{item.orderinfo.parentname01}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.parentname01">
                <span class="name">直接返现：</span>
                <span class="value">￥{{item.orderinfo.parentimoney01}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.parentname02">
                <span class="name">间接上级：</span>
                <span class="value">{{item.orderinfo.parentname02}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.parentname02">
                <span class="name">间接返现：</span>
                <span class="value">￥{{item.orderinfo.parentimoney02}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.resulttype==5 && item.orderinfo.isship">
                <span class="name">快递公司：</span>
                <span class="value">{{item.orderinfo.shipcompanyname}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.resulttype==5 && item.orderinfo.isship">
                <span class="name">快递单号：</span>
                <span class="value">{{item.orderinfo.shipno}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.resulttype==4">
                <span class="name">核销状态：</span>
                <span class="value">{{item.orderinfo.ischeck?'已核销':'未核销'}}</span>
            </div>
        </div>
        <div class="outbox ship"  v-if="item.orderinfo.resulttype==5 || item.formdata.length">
            <div class="box" v-if="item.orderinfo.resulttype==5">
                <span class="name">收货姓名：</span>
                <span class="value">{{item.orderinfo.shipname}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.resulttype==5">
                <span class="name">收货号码：</span>
                <span class="value">{{item.orderinfo.shiptel}}</span>
            </div>
            <div class="box" v-if="item.orderinfo.resulttype==5">
                <span class="name">收货地址：</span>
                <span class="value">{{item.orderinfo.shipaddress}}</span>
            </div>
        </div>
        <div class="outbox formData" v-for="(obj,index) in item.formdata" :key="index">
            <div class="box">
                <span>{{obj.colname}}：</span>
                <span>{{obj.colvalue}}</span>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getOrderDetail} from 'api/nationalDistribution'
import {mapActions} from 'vuex'
export default {
    name: 'popOrderView',
    data() {
        return {
            centerDialogVisible: false,
            param: {
                eventinnerid: '',
                orderno: ''
            },
            item: {
                orderinfo: {
                    resulttype: ''// 凭证类型:1自定义 2跳转链接 3兑换码 4核销码 5配送型
                },
                formdata: []
            }
        }
    },
    props: [],
    mounted() {
    },
    methods: {
        open(eventinnerid, orderno) {
            this.centerDialogVisible = true
            this.param.eventinnerid = eventinnerid
            this.param.orderno = orderno
            this._getView()
        },
        _getView() {
            this.setLoading(true)
            getOrderDetail({
                data: this.param,
                success: data => {
                    this.setLoading(false)
                    this.item = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.popOrderView {
    .outbox{
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .box{
            width: 50%;
            flex-basis: 50%;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 10px 0;
            line-height: 1;
            .name{
                white-space: nowrap;
            }
            .value{
                line-height: 22px;
            }
        }
        .hbox{
            height: 50px;
        }
    }
    .img{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .imageText{
        display: flex;
        align-items: center;
    }
    .ship{
        border-top: 1px solid $line;
        margin-top: 10px;
        padding-top: 10px;
    }
    .formData{
        .box{
            width: 100%;
        }
    }
}
</style>
